var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8839 20.8839C23.372 20.3957 23.372 19.6043 22.8839 19.1161L14.9289 11.1612C14.4408 10.673 13.6493 10.673 13.1612 11.1612C12.673 11.6493 12.673 12.4408 13.1612 12.9289L20.2322 20L13.1612 27.0711C12.673 27.5592 12.673 28.3507 13.1612 28.8388C13.6493 29.327 14.4408 29.327 14.9289 28.8388L22.8839 20.8839ZM0 21.25H22V18.75H0V21.25Z",
    fill: "#424895"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightMenu);
export default __webpack_public_path__ + "static/media/arrow-right-menu.11cb291caa9e786ec168d5facbcbe8e5.svg";
export { ForwardRef as ReactComponent };